import { clsx } from "clsx"

type BadgeVariant = "success" | "warning" | "danger" | "info" | "muted" | "purple"

interface BadgeProps {
  variant: BadgeVariant
  children: React.ReactNode
  dot?: boolean
}

const STYLES: Record<BadgeVariant, string> = {
  success: "bg-green-50 text-green-700 ring-1 ring-green-200",
  warning: "bg-amber-50 text-amber-700 ring-1 ring-amber-200",
  danger:  "bg-red-50 text-red-700 ring-1 ring-red-200",
  info:    "bg-blue-50 text-blue-700 ring-1 ring-blue-200",
  muted:   "bg-gray-100 text-gray-500 ring-1 ring-gray-200",
  purple:  "bg-zimrah-50 text-zimrah-700 ring-1 ring-zimrah-200",
}

const DOT_STYLES: Record<BadgeVariant, string> = {
  success: "bg-green-500",
  warning: "bg-amber-500",
  danger:  "bg-red-500",
  info:    "bg-blue-500",
  muted:   "bg-gray-400",
  purple:  "bg-zimrah-500",
}

export function Badge({ variant, children, dot }: BadgeProps) {
  return (
    <span className={clsx("inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold", STYLES[variant])}>
      {dot && <span className={clsx("w-1.5 h-1.5 rounded-full", DOT_STYLES[variant])} />}
      {children}
    </span>
  )
}

export function statusBadge(status: string, isSuspended: boolean) {
  if (isSuspended) return <Badge variant="danger" dot>Suspended</Badge>
  switch (status) {
    case "active":      return <Badge variant="success" dot>Active</Badge>
    case "grace_period": return <Badge variant="warning" dot>Grace Period</Badge>
    case "taken_over":  return <Badge variant="danger" dot>Taken Over</Badge>
    case "cancelled":   return <Badge variant="muted" dot>Cancelled</Badge>
    default:            return <Badge variant="muted" dot>Inactive</Badge>
  }
}